import * as React from 'react';
import './index.scss';

export const CoalitionsHeader: React.FC = () => (
  <p className="CoalitionsHeader">
    <span>Voti</span>
    <span>%</span>
  </p>
);
